// extracted by mini-css-extract-plugin
module.exports =  {"textInputTag":"textInputTag__J5J9J","tagsList":"tagsList__VA8bz","lastTagsListItem":"lastTagsListItem__dXCA4","tagInput":"tagInput__yoVm1"};